import { Accordion } from "flowbite-react"
  const EnterpriseSoftwareFAQ: React.FC = () => { return (
        <>
          <Accordion>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title">What is enterprise software development?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                <div className="fs-md mb-0 text-secondary">
                Enterprise software development involves creating customized software solutions tailored to meet the specific needs of businesses and organizations, optimizing their processes and improving efficiency.
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title"> How do enterprise mobility solutions benefit my business?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  Enterprise mobility solutions provide secure, seamless mobile access to enterprise data, enhancing business processes, productivity, and customer engagement.
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title"> Why is data integration important for enterprises?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  Data integration helps enterprises overcome data silos, enabling real-time data sharing and streamlined workflows across different departments, enhancing operational efficiency.
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title">What are the advantages of migrating to the cloud with enterprise cloud solutions?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  Enterprise cloud solutions offer scalability, flexibility, and cost-efficiency, enabling businesses to innovate, improve agility, and accelerate growth by migrating and managing applications on leading cloud platforms.
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title">How much does it cost to develop an enterprise software? </Accordion.Title>
                <Accordion.Content className="accordion-border">
                <div className="fs-md mb-0 text-secondary">
                The cost of developing enterprise software depends on various factors, including:
                    <ul className="list mt-4 mb-4">
                      <li>The option of operating system (iOS or Android).</li>
                      <li>Features like login authentication, notification management, and user profiles.</li>
                      <li>Privacy settings and content moderation.</li>
                      <li>Integration with website CMS or ERP.</li>
                      <li>Mobile payment and e-commerce support.</li>
                      <li>Compliance measures like HIPAA.</li>
                      <li>Utilization of sensors and APIs.</li>
                      <li>Data caching and synchronization.</li>
                    </ul>
                    However, for more complex features and integrations, the cost can range from $100,000 to $500,000.
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title">What are the types of enterprise software you can build?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                <div className="fs-md mb-0 text-secondary">
                We can develop custom enterprise software for various business functions. An enterprise software can be considered a system as they integrate with a firms organizational process.<br/>
                    <ul className="list mb-0 mt-4">
                      <li>Enterprise Resource Planning (ERP)</li>
                      <li>Low-code Development Platforms (LCDP)</li>
                      <li>Business Intelligence (BI)</li>
                      <li>Business Process Management (BPM)</li>
                      <li>Content Management System (CMS)</li>
                      <li>Customer Relationship Management (CRM)</li>
                      <li>Database Management System (DBMS)</li>
                      <li>Enterprise Asset Management (EAM)</li>
                      <li>Resource Management (HRM)</li>
                      <li>Knowledge Management (KM)</li>
                      <li>Networking and Information Security</li>
                      <li>Intrusion Detection Prevention (IDS)</li>
                      <li>Software-Defined Networking (SDN)</li>
                      <li>Security Information Event Management (SIEM)</li>
                      <li>Product Data Management (PDM)</li>
                      <li>Product Information Management (PIM)</li>
                      <li>Product Lifecycle Management (PLM)</li>
                      <li>Supply Chain Management (SCM)</li>
                      <li>Software Configuration Management (SCM)</li>
                    </ul>
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
            </Accordion>
        </>
        )
}

export default EnterpriseSoftwareFAQ
